import Section from "../components/Section";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};
const item = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45 } },
};

export default function AboutSymptoms() {
  return (
    <>
      {/* 1) Categories */}
      <Section eyebrow="SYMPTOMS" title="What are the symptoms of Thalassemia?">
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="grid md:grid-cols-3 gap-6"
        >
          <Category
            variants={item}
            title="Common"
            // img="/common.jpg"
            items={[
              { icon: "fa-face-tired", title: "Tiredness", desc: "Low haemoglobin means less oxygen → fatigue." },
              { icon: "fa-droplet", title: "Pale / Yellow Skin", desc: "Anaemia makes skin look pale or slightly yellow." },
            ]}
          />
          <Category
            variants={item}
            title="Children & Growth"
            // img="/images/symptoms/children.jpg"
            items={[
              { icon: "fa-child", title: "Slow Growth", desc: "Children with severe thalassemia may grow slowly." },
              { icon: "fa-bone", title: "Bone Changes", desc: "Overactive bone marrow can affect facial bones." },
            ]}
          />
          <Category
            variants={item}
            title="When Severe"
            // img="/images/symptoms/severe.jpg"
            items={[
              { icon: "fa-shield-virus", title: "Frequent Infections", desc: "Lower immunity raises infection risk." },
              { icon: "fa-heart-pulse", title: "Enlarged Spleen", desc: "Due to excess blood breakdown." },
            ]}
          />
        </motion.div>
      </Section>

      {/* 2) When to see a doctor */}
      <Section eyebrow="When to Act" title="When should I consult a doctor?">
        <motion.ul
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="grid sm:grid-cols-3 gap-4"
        >
          <Bullet variants={item}>Persistent fatigue or shortness of breath</Bullet>
          <Bullet variants={item}>Very pale or yellowish skin</Bullet>
          <Bullet variants={item}>Noticeable abdominal fullness (possible spleen)</Bullet>
        </motion.ul>
        <p className="text-slate-600 mt-4">
          Symptoms can overlap with other anaemias. Only tests confirm thalassemia.
        </p>
      </Section>
    </>
  );
}

function Category({ title, items, img, variants }) {
  return (
    <motion.div
      variants={variants}
      whileHover={{ y: -3 }}
      className="relative rounded-2xl border p-6 bg-white shadow-sm"
    >
      {/* Image placeholder */}
      {/* <div className="absolute right-4 top-4 h-14 w-20 overflow-hidden rounded-lg border bg-slate-50">
        <img src={img} alt="" className="h-full w-full object-cover" />
      </div> */}

      <h3 className="font-semibold text-slate-900 mb-4">{title}</h3>
      <div className="grid gap-4">
        {items.map((x) => (
          <IconCard key={x.title} icon={x.icon} title={x.title} desc={x.desc} />
        ))}
      </div>
    </motion.div>
  );
}

function IconCard({ icon, title, desc }) {
  return (
    <div className="flex items-start gap-3">
      <div className="h-10 w-10 rounded-lg border flex items-center justify-center">
        <i className={`fa-solid ${icon} text-lg`} />
      </div>
      <div>
        <h4 className="font-semibold text-slate-900">{title}</h4>
        <p className="text-slate-600 text-sm">{desc}</p>
      </div>
    </div>
  );
}

function Bullet({ children, variants }) {
  return (
    <motion.li
      variants={variants}
      whileHover={{ y: -2 }}
      className="rounded-xl border bg-white p-4 shadow-sm flex items-start gap-3"
    >
      <i className="fa-solid fa-circle-info text-sky-600 mt-1" />
      <span className="text-slate-700">{children}</span>
    </motion.li>
  );
}


